import React from 'react'
import PropTypes from 'prop-types'

// The Bhanzu crescent, as in public/favicon.svg (made from the logo's
// .cls-2 path by the task's make_icons.sh). CrescentMark.test.js fails if
// the two drift apart.
export const CRESCENT_VIEW_BOX = '353.99 46.67 150.64 150.64'
export const CRESCENT_PATH =
    'M489.65,114.62a64.9,64.9,0,0,0-121.1-24.38H374a60.22,60.22,0,0,1,6.91-9.58A51.16,51.16,0,0,1,398.1,67.82a48.22,48.22,0,0,1,17.64-4.1A43.48,43.48,0,0,1,442.51,72a46.48,46.48,0,0,1,13.74,15.12c3,5.48,4.76,11.84,3.83,18.11-1,6.93-5.27,12.71-10.77,16.87a26.87,26.87,0,0,1,5.83,5.88,26.52,26.52,0,0,1,4.32,19,38,38,0,0,1-8.39,18.75,40.27,40.27,0,0,1-21.21,13.05c-7.86,2.05-12.52,2.57-23.9-.28l-.08,0c-7.32-2.07-10.77-2.91-20.55-11.09l-7.23-.68a64.92,64.92,0,0,0,111.55-52.12Z'

/** The Bhanzu crescent in the current text colour; decoration (its button names it). */
const CrescentMark = ({ size = 24 }) => (
    <svg
        viewBox={CRESCENT_VIEW_BOX}
        width={size}
        height={size}
        aria-hidden="true"
        focusable="false"
    >
        <path fill="currentColor" d={CRESCENT_PATH} />
    </svg>
)

CrescentMark.propTypes = { size: PropTypes.number }

export default CrescentMark
